import {
  CountTicketGroupsTicketsPCsQuery,
  CountTicketGroupsTicketsPCsQueryVariables,
  GetTicketGroupsTicketsPCsWithSeatingPlanDataQuery,
  GetTicketGroupsTicketsPCsWithSeatingPlanDataQueryVariables,
  GetProductCategoriesIdsByPriceIdsQuery,
  GetProductCategoriesIdsByPriceIdsQueryVariables,
} from "@/types/gql/generated/graphql";
import {
  COUNT_TicketGroupsTicketsPCs,
  GET_ProductCategoriesIdsByPriceIds,
  GET_TicketGroupsTicketsPCsWithSeatingPlanData,
} from "@/api/gql/queries/ticket-group.graphql";
import { apolloClient } from "@/utils/graphql-client";
import { IPaginate } from "@/types/app";

export async function getTicketGroupsTicketsPCsWithSeatingPlanData(
  ticketGroupIds: number[],
  pagination?: IPaginate
) {
  console.log("hi from getTicketGroupsTicketsPCsWithSeatingPlanData");
  const variables: GetTicketGroupsTicketsPCsWithSeatingPlanDataQueryVariables =
    {
      ticketGroups: `(ticket_group_id,in,${ticketGroupIds.join(",")})`,
    };

  if (pagination) {
    const { skip, limit } = pagination;
    variables.skip = skip;
    variables.limit = limit;
  }

  const res = await apolloClient.query<
    GetTicketGroupsTicketsPCsWithSeatingPlanDataQuery,
    GetTicketGroupsTicketsPCsWithSeatingPlanDataQueryVariables
  >({
    query: GET_TicketGroupsTicketsPCsWithSeatingPlanData,
    variables,
  });

  return res.data;
}

export async function countTicketGroupsTicketsPCs(ticketGroupIds: number[]) {
  const variables: CountTicketGroupsTicketsPCsQueryVariables = {
    ticketGroups: `(ticket_group_id,in,${ticketGroupIds.join(",")})`,
  };

  const res = await apolloClient.query<
    CountTicketGroupsTicketsPCsQuery,
    CountTicketGroupsTicketsPCsQueryVariables
  >({
    query: COUNT_TicketGroupsTicketsPCs,
    variables,
  });

  return res.data;
}

export async function getProductCategoriesIdsByPriceIds(
  priceIds: number[],
  pagination?: IPaginate
) {
  const variables: GetProductCategoriesIdsByPriceIdsQueryVariables = {
    prices: `(id,in,${priceIds.join(",")})`,
  };

  if (pagination) {
    const { skip, limit } = pagination;
    variables.skip = skip;
    variables.limit = limit;
  }

  const res = await apolloClient.query<
    GetProductCategoriesIdsByPriceIdsQuery,
    GetProductCategoriesIdsByPriceIdsQueryVariables
  >({
    query: GET_ProductCategoriesIdsByPriceIds,
    variables,
  });

  return res.data;
}
